export const notNullNorUndefined = <T = any>(
  value: T
): value is NonNullable<T> => value !== null && value !== undefined;

export const isNullorUndefined = (value: unknown): value is null | undefined =>
  value === null || value === undefined;
